import { Col, Row, Typography } from "antd";

const Introduce = () => {
  const { Text } = Typography;

  return (
    <>
      <Row className="!h-[250px] sm:h-[350px]  lg:!h-[480px] !overflow-auto bg-gradient-to-b from-[#ffc600] to-[#ecd171] ">
        <Col
          xs={24}
          className="flex flex-col justify-center items-center text-center   !w-full  "
        >
          <div className="!w-[360px]  sm:!w-[700px] md:!w-[800px] !flex flex-col !gap-1 md:!gap-2 lg:!gap-4 !p-0 sm:!p-4 ">
            <Text className="!text-2xl sm:!text-4xl xl:!text-6xl  !text-black !font-bold">
              Sariilanlar.com Doping
            </Text>
            <Text className="!text-sm sm:!text-base xl:!text-xl !text-black !font-bold">
              Sariilanlar.com dopingleri, ilanlarınızı öne çıkarır ve
              rakiplerinden ayırır.
            </Text>
            <Text className=" !text-xs sm:!text-sm   xl:!text-lg !text-black">
              İlanlarınız, Sariilanlar.com dopingleri sayesinde çok daha geniş
              bir kitleye ulaşır ve potansiyel alıcılar tarafından daha fazla
              görüntülenir. Böylece, ürününüzü veya hizmetinizi en kısa sürede
              satabilir ya da kiralayabilirsiniz. İlanınızın görünürlüğü
              arttıkça, doğru alıcıya hızlıca ulaşmanız kolaylaşır ve satış
              süreciniz daha verimli hale gelir.
            </Text>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Introduce;
